export default __webpack_public_path__ + "static/media/ionicons.52cc4717.eot";